module.exports = __webpack_public_path__ + "45ca0625b5061abbf3f10464a007525e.png";